import postsLists from "./imports/postsLists";
import pageWydarzenia from "./imports/pageWydarzenia";

window.addEventListener('DOMContentLoaded', (ev) => {
    postsLists();
    pageWydarzenia();
});